<template>
  <div class="home">
    Welcome to nomado!
  </div>
</template>

<script>
// @ is an alias to /src

export default {
    name: 'app.index',
    components: {

    }
};
</script>
